import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IComboboxLookupProps {
    id: string;
    operation?: number;
    onChange?: (selectedLookupId: string) => void;

    selectedItemLookupCode?: string;
    selectedItemLookupId?: string;

    disabled?: boolean;

    itemsLookup?: Immutable.List<FlatLookupView>;

    className?: string;

    includeCodeInName?: boolean;

    operationArg1?: any;
    operationArg2?: any;
    operationArg3?: any;
}

class ComboboxLookup extends React.Component<IComboboxLookupProps, never> {
    public render(): JSX.Element {
        var self = this;

        var emptyLookup = new FlatLookupView();
        emptyLookup.LookupID = "";
        emptyLookup.LookupPosition = 0;
        emptyLookup.LookupCode = null;
        emptyLookup.en = "";
        emptyLookup.fr = "";

        var selectedItemLookupId = this.props.selectedItemLookupId;

        var itemsLookup: Immutable.List<FlatLookupView> = null;
        if (this.props.itemsLookup != null) {
            itemsLookup = this.props.itemsLookup.push(emptyLookup);

            if (this.props.selectedItemLookupCode != null) {
                let _tmpSelected = this.props.itemsLookup.filter(x => x.LookupCode == this.props.selectedItemLookupCode);
                if (_tmpSelected != null && _tmpSelected.count() > 0)
                    selectedItemLookupId = _tmpSelected.get(0).LookupID;
            }
        }

        var Id = this.props.id;
        var className: string = "";
        if (this.props.className != null)
            className = this.props.className;

        var disabled: boolean;
        if (this.props.disabled != true)
            disabled = false;

        // Array of Lookups
        return (
            <select key={Id + "_selectlk"} className={"form-control myle-control minimal " + className} disabled={disabled} onChange={this.onChangeLookup.bind(this)} value={selectedItemLookupId}>
                {this.props.itemsLookup != null && itemsLookup.map(g => (
                    <option key={Id + "_" + g.LookupID} value={g.LookupID}>{self.props.includeCodeInName == true ? (g.LookupCode + " - " + g.GetValue()) : (g.GetValue())}</option>
                ))}
            </select>
        );
    }

    public onChangeLookup(e: React.ChangeEvent<HTMLSelectElement>): void {
        var selectedLookupId = e.target.value;
        this.ChangeLookup(selectedLookupId);
    }

    public ChangeLookup(selectedLookupId: string): void {
        var self = this;

        var operation = new LocalEvent(self.props.operation);
        operation.AddItem("value", selectedLookupId);
        operation.AddItem("id", self.props.id);
        operation.AddItem("arg1", self.props.operationArg1);
        operation.AddItem("arg2", self.props.operationArg2);
        operation.AddItem("arg3", self.props.operationArg3);
        LocalEventDispatcher.dispatch(operation);

        if (self.props.onChange != null)
            self.props.onChange(selectedLookupId);
    }
}

export { ComboboxLookup };
